/** 个人中心 - 我的钱包模块 */
import request from '../request'
import apis from '../apis'

export default {

    /** 获取是否为自己的团组，控制是否显示团组预算详情页面的追加总预算按钮 */
    getMrsAddPermissionSer(params) {
        return request.get(apis.GET_MRS_ADD_PERMISSION, { params });
    },

    /** 获取我的钱包统计图表数据 */
    initStaticsChartsSer(params) {
        return request.get(apis.INIT_STATICS_CHARTS_DATA, { params });
    },

    /** 获取我的钱包明细图表数据 */
    initDetailChartsSer(params) {
        return request.get(apis.INIT_DETAIL_CHARTS_DATA, { params });
    },

    /** 导出钱包预算统计列表数据 */
    exportMwBudgetSer(params) {
        return request.get(apis.EXPORT_MW_BUDGET, { params });
    },

    /** 获取费用明细列表数据 */
    getOrderExpanseListSer({ param, pageVO }) {
        return request.get(`${apis.GET_ORDER_EXPANSE_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, { params: param });
    }
}
